"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$IsAppInstalled = exports.$InstalledRelatedApp = void 0;
const jotai_1 = require("jotai");
exports.$InstalledRelatedApp = (0, jotai_1.atom)('pending');
exports.$InstalledRelatedApp.debugLabel = '$InstalledRelatedApp';
exports.$IsAppInstalled = (0, jotai_1.atom)((get) => {
    const installedRelatedApp = get(exports.$InstalledRelatedApp);
    return !['pending', null].includes(installedRelatedApp);
});
exports.$IsAppInstalled.debugLabel = '$IsAppInstalled';
